import FooterComponent from './footer';

export default FooterComponent;